module.exports = __webpack_public_path__ + "img/色.5da56671.png";